var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-invoice-sync-item-table',{attrs:{"title":_vm.$t('global.models.invoice_sync_item.heading'),"subtitle":_vm.$t('global.models.invoice_sync_item.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }